const commonFi = {
  navigation: {
    portfolio: "Portfolio",
    services: "Kuvaukset",
    pricing: "Hinnasto",
    about: "Kuvaaja",
    contact: "Yhteys",
  },

  pages: {
    home: "Etusivu",
    portfolio: "Portfolio",
    services: "Kuvaukset",
    pricing: "Hinnasto",
    about: "Kuvaaja",
    contact: "Yhteys",
    notFound: "Sivua ei löytynyt",
  },

  /*
    ==========================================================
    HERO
    ==========================================================
  */

  hero: {
    eyebrow: "Photography · Finland",

    title:
      "Hetkiä, joihin haluat palata.",

    description:
      "Ajattomia kuvia ihmisistä, tunteista ja tarinoista, jotka ovat säilyttämisen arvoisia.",

    portfolio:
      "Tutustu portfolioon",

    services:
      "Valitse kuvaus",

    scroll:
      "Vieritä",
  },

  /*
    Foundation-testisisältö muiden sivujen
    väliaikaiseen käyttöön.
  */


  /*
    ==========================================================
    EDITORIAL INTRO
    ==========================================================
  */

  editorialIntro: {
    eyebrow: "Johdanto",

    title:
      "Kuvat eivät pysäytä aikaa. Ne auttavat meitä palaamaan siihen.",

    description:
      "Parhaat kuvat syntyvät hetkistä, joita ei tarvitse pakottaa. Katseesta, kosketuksesta, naurusta ja kaikesta siitä, mikä tapahtuu niiden välissä.",

    footer:
      "Aitoja hetkiä · Ajattomia muistoja",
  },

  /*
    ==========================================================
    PORTFOLIO STORY
    ==========================================================
  */

  portfolioStory: {
    eyebrow: "Valikoitu portfolio",

    title:
      "Tarinoita kuvina.",

    previous:
      "Edellinen kuva",

    next:
      "Seuraava kuva",

    swipe:
      "Pyyhkäise",

    items: {
      one: {
        category: "Häät · Editorial",
        title: "Kukkien keskellä",
        alt: "Hääpari kukkien keskellä",
      },

      two: {
        category: "Morsian · Muotokuva",
        title: "Hiljainen hetki",
        alt: "Morsiamen muotokuva luonnonvalossa",
      },

      three: {
        category: "Häät · Maisema",
        title: "Valoa kohti",
        alt: "Hääpari maisemassa auringonlaskussa",
      },

      four: {
        category: "Hääpäivä · Yksityiskohdat",
        title: "Pienet asiat",
        alt: "Hääpäivän yksityiskohta",
      },

      five: {
        category: "Tarina · Hetket",
        title: "Siinä hetkessä",
        alt: "Luonnollinen hetki hääpäivänä",
      },
    },
  },

  /*
    ==========================================================
    SESSIONS
    ==========================================================
  */

  sessionsSection: {
    eyebrow:
      "Kuvaukset",

    title:
      "Jokaisella tarinalla on oma rytminsä.",

    description:
      "Kuvaus rakentuu ihmisistä, tunnelmasta ja hetkestä. Tavoitteena ei ole täydellinen poseeraus vaan kuvat, joissa tunnistat itsesi ja oman tarinasi.",

    allSessions:
      "Tutustu kaikkiin kuvauksiin",

    items: {
      weddings: {
        eyebrow:
          "Hääkuvaus",

        title:
          "Teidän päivänne.",

        description:
          "Dokumentaarista ja ajatonta hääkuvausta pienistä yksityiskohdista päivän suurimpiin hetkiin.",

        alt:
          "Hääpari maisemassa",
      },

      couples: {
        eyebrow:
          "Parikuvaus",

        title:
          "Kaksi ihmistä.",

        description:
          "Rento kuvaus ilman jäykkiä poseerauksia — yhdessäoloa, liikettä ja teille ominaisia hetkiä.",

        alt:
          "Pariskunta kukkien keskellä",
      },

      portraits: {
        eyebrow:
          "Muotokuvaus",

        title:
          "Sinun näköisesi.",

        description:
          "Luonnollisia muotokuvia, joissa tärkeintä ei ole kameralle esiintyminen vaan oma läsnäolosi.",

        alt:
          "Muotokuva luonnonvalossa",
      },
    },
  },

  /*
    ==========================================================
    ABOUT
    ==========================================================
  */

  aboutSection: {
    eyebrow:
      "Kuvaaja",

    intro:
      "Kameran toisella puolella",

    title:
      "Läsnä hetkessä.",

    description:
      "Kuvaajana tehtäväni ei ole rakentaa hetkestä täydellistä, vaan huomata se sellaisena kuin se tapahtuu.",

    descriptionTwo:
      "Haluan, että kuvaustilanne tuntuu rennolta ja omalta. Kun kameran voi hetkeksi unohtaa, kuviin jää jotain paljon tärkeämpää kuin poseeraus.",

    link:
      "Tutustu kuvaajaan",

    imageAlt:
      "Valokuvaaja",

    caption:
      "Photographer · Finland",

    quote:
      "Parhaassa kuvassa et näe vain sitä, miltä hetki näytti. Muistat, miltä se tuntui.",
  },

  /*
    ==========================================================
    CONTACT
    ==========================================================
  */

  contactSection: {
    eyebrow:
      "Yhteys",

    intro:
      "Aloitetaan tarina",

    title:
      "Kerro minulle, mitä haluat muistaa.",

    description:
      "Jokainen kuvaus alkaa ajatuksesta. Kerro tulevasta päivästä, ihmisistä tai hetkestä, jonka haluat säilyttää.",

    contact:
      "Ota yhteyttä",

    sessions:
      "Tutustu kuvauksiin",
  },

  footer: {
    tagline:
      "Ajattomia kuvia ihmisistä, tunteista ja tarinoista.",

    navigation:
      "Alatunnisteen navigaatio",

    location:
      "Photography · Finland",
  },

  /*
    ==========================================================
    PORTFOLIO PAGE
    ==========================================================
  */

  portfolioPage: {
    eyebrow:
      "Portfolio · Valitut tarinat",

    title:
      "Kuvia, joihin voi palata.",

    description:
      "Yksi päivä ei mahdu yhteen kuvaan. Siksi portfolio rakentuu tarinoista — katseista, yksityiskohdista, maisemista ja hetkistä niiden välissä.",

    albumEyebrow:
      "Albumitarinat",

    albumTitle:
      "Tarinanne albumina.",

    albumDescription:
      "Kuvia ei ole tarkoitettu vain selattaviksi. Parhaimmillaan ne muodostavat kokonaisuuden, jonka ääreen haluaa palata vielä vuosien päästä.",

    categories: {
      all:
        "Kaikki",

      weddings:
        "Häät",

      couples:
        "Parit",

      portraits:
        "Muotokuvat",
    },

    loadMore:
      "Lataa lisää",

    previous:
      "Edellinen tarina",

    next:
      "Seuraava tarina",

    swipe:
      "Pyyhkäise",

    openImage:
      "Avaa kuva",

    closeImage:
      "Sulje kuva",

    lightbox:
      "Suuri kuva",

    ctaEyebrow:
      "Sinun tarinasi",

    ctaTitle:
      "Seuraava tarina voi olla teidän.",

    viewSessions:
      "Tutustu kuvauksiin",

  },
  demo: {
    eyebrow: "Photography Premium",

    title:
      "Valokuville rakennettu digitaalinen tila.",

    description:
      "Premium-valokuvaajasivupohja, jossa sisältö, teemat, kielet ja brändi voidaan vaihtaa ilman ydinkomponenttien uudelleenkirjoittamista.",

    portfolio:
      "Tutustu portfolioon",

    services:
      "Valitse kuvaus",
  },

  controls: {
    language: "Kieli",
    theme: "Teema",
    menu: "Valikko",
    openMenu: "Avaa valikko",
    closeMenu: "Sulje valikko",
  },

  notFound: {
    code: "404",

    title:
      "Sivua ei löytynyt.",

    description:
      "Hakemaasi sivua ei ole olemassa tai sen osoite on muuttunut.",

    backHome:
      "Takaisin etusivulle",
  },
};

export default commonFi;
